"use strict";

Shopify.theme.jsCustomReviews = {
  init: function init($section) {
	const $sliderEl = $section.find('[data-slider]')
    if(!$sliderEl.length)return;
    
    const $slides = $sliderEl.find('[data-index]')
    
    let slider = $sliderEl
    slider.on( 'ready.flickity', function() {
      let height = 0
      $slides.each(function(index,child){
      	height = $(child).outerHeight() > height ?
          $(child).outerHeight():
          height
      })
      console.log(height)
      $slides.css('height',height)
    });
    slider = $('[data-slider]').flickity({
      wrapAround: true,
      cellAlign:'center',
      prevNextButtons: true,
      pageDots: true,
    }); 
    
    setTimeout(function () {
      slider.flickity('resize');
    }, 500);
    

  },
  blockSelect: function blockSelect($section, blockId) {
    var slider = $section.find('[data-slider]');
    var slideIndex = $('#shopify-section-' + blockId).data('index');
    slider.flickity('select', slideIndex, true, true);
  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
};